/**
 * 取得載客上車照片
 * @param driverid
 * @param filename
 */
export function PickUpPassengerPhotoUrlFormat(
  imagePath: string,
  size: ImageSystemSize = ImageSystemSize.Large,
): string {
  const [directory, date, sizedir, filename] = imagePath.split("/");

  return new URL(
    `${UrlPathEnum.Photo}/${directory}/${date}/${size}/${filename}`,
    process.env.NODE_ENV === "development"
      ? "http://60.199.131.69:8012"
      : process.env.VUE_APP_BASE_API_URL,
  ).toString();
}

export enum UrlPathEnum {
  Photo = "Photo",
  DriverPhoto = "Driver",
  VehiclePhoto = "Vehicle",
  CompanyPhoto = "Company",
  AdvertisementPhoto = "Advertisement/AdvertisementPhotos",
}

/** 系統圖片尺寸 (ImageUtility) */
export enum ImageSystemSize {
  Large = "Large",
  Medium = "Medium",
  Small = "Small",
  Src = "Src",
}
